import zhLocale from "element-ui/lib/locale/lang/zh-CN";
zhLocale.el.pagination.goto = "跳至";
export default {
  ...zhLocale,
  main: {
    title: "重庆电信职业学院 | 一网通办",
    submit: "提交",
    more: "更多",
    welcome: "重庆电信职业学院欢迎你！",
  },
  user: {
    moring: "早上好",
    noon: "中午好",
    afternoon: "下午好",
    evening: "晚上好",
  },
  mobile: {
    accountName: "账号",
    inputAccount: "请输入账号",
    inputPwd: "请输入密码",
    verificationCode: "验证码",
    inputCode: "请输入验证码",
    inputSearch: "输入搜索",
    commonList: "常用列表",
    appCenter: "应用中心",
    moreService: "登录享受更多个性化服务",
    toLogin: "去登录",
    MessageDetail: "消息详情",
    selectLanguage: "选择语言",
    home: {
      welcome: "欢迎来到",
      school: "重庆电信职业学院",
      myApps: "我的应用",
      news: "新闻资讯",
      informations: "信息公告",
      collection: "收藏应用",
      accounts: "切换账户",
      messages: "消息中心",
    },
    profile: {
      head: "我的头像",
      name: "姓名",
      bindEmail: "绑定邮箱",
      bindAccount: "绑定账号",
      bindPhone: "绑定手机",
      loginLogs: "登录日志",
      selectDate: "选择日期范围",
      close: "关闭",
      startDate: "开始日期",
      endDate: "结束日期",
      confirm: "确认",
      appRecords: "应用访问记录",
      accountRecords: "账号维护记录",
      passwordRecords: "密码维护记录",
      security: "密保设置",
      time: "时间",
      status: "状态",
      successful: "成功",
      failed: "失败",
      changeEmail: "修改邮箱",
      email: "邮箱",
      inputEmail: "请输入邮箱",
      imgCode: "图形验证码",
      inputImgCode: "请输入图形验证码",
      emailCode: "邮箱验证码",
      inputEmailCode: "请输入邮箱验证码",
      sendCode: "发送验证码",
      reSend: "{key}秒后重新发送",
      confirmLogout: "确认注销吗？",
      confirm: "确认",
      cancel: "取消",
      trustDevice: "信任/FIDO设备",
      subscription: "订阅消息",
      trust: "信任",
      isTrusted: "是否已信任设备",
      deleteTrust: "删除",
      Yes: "是",
      No: "否",
      changePhone: "修改手机号",
      phone: "手机号",
      inputPhone: "请输入手机号",
      phoneCode: "手机验证码",
      inputPhoneCode: "请输入手机验证码",
    },
    account: {
      username: "用户名",
      inputUserName: "请输入用户名",
      bindNew: "绑定新账号",
      save: "保存",
      unbind: "确定解绑吗？",
      default: "默认账号",
      main: "当前账号",
      bindSuccess: "绑定成功",
    },
  },
  login: {
    welcome: "欢迎使用数字身份认证",
    wechat: "微信登录",
    dingding: "钉钉登录",
    account: "账号登录",
    login: "登录",
    activatiton: "账号激活",
    appeal: "账号申诉",
    inputPwd: "密码同原信息门户",
    inputAccount: "请输入学号或工号",
    inputCode: "请输入验证码",
    useWeChat: "请使用微信扫描二维码登录",
    codeOutOfDate: "验证码已过期，请",
    refreshCode: "刷新",
    periodOfCode: "二维码有效期：",
    loginSuccess: "登录成功！",
    redirecting: "正在跳转...",
    getCodeFail: "获取验证码失败",
    code: "请输入验证码",
    forgetPassword: "忘记密码？",
    password: "密码",
    text1:"学生校友忘记密码可点击忘记密码进行重置",
    text2:"首次登录请点击忘记密码进行重置",
    text3:"严禁在本互联网非涉密平台传输、处理国家秘密，请确认扫描上传、处理的文件资料不涉及国家秘密",
  },
  menubar: {
    home: "首页",
    affairs: "事务中心",
    analysis: "能效分析",
    service: "服务指南",
    systemEntries: "常用系统",
    myAffairs: "我的事务",
    search: "搜索",
    message: "消息",
    instructions: "使用说明",
    profile: "个人中心",
    logout: "退出登录",
    mine: "我的",
    apps: "应用",
  },
  home: {
    hi: "Hi，你好！",
    welcome: "欢迎来到重庆电信职业学院",
    inputKeyWord: "请输入关键词",
    search: "搜一下",
    hotWord: "热词搜索",
    service: "推荐服务",
    stuProject: "新生专题",
    serviceDes: "精准推荐服务，个性化匹配，提升用户体验。",
    viewMore: "查看更多",
    system: "推荐系统",
    departmentDes: "个部门入驻，",
    total: "共计",
    systemService: "个服务",
    refresh: "换一批",
    specialized: "专题服务",
    specializedDes: "专业专题服务，深度解析，满足特定需求。",
    departmentService: "直通部门",
    departmentServiceDes: "直通部门服务，快速响应，高效解决问题。",
    convenienceServices: "便捷服务",
    convenienceServicesDes: "贴心便捷服务，简化流程，便捷民众生活。",
    enter: "点击进入",
    times: "次使用",
  },
  footer: {
    vpnHotline: "VPN服务热线:",
    passwordHotline: "统一认证密码修改热线:",
    networkHotline: "网络故障热线:",
    emailHotline: "邮箱开户热线:",
    stationHotline: "站群维护热线:",
    accountHotline: "校园开户热线:",
    organizer: "主办单位: 重庆电信职业学院",
    address: "地址: 重庆市双桥经开区巴岳大道9号",
    technical: "技术支持: 信息中心",
    suggestion:
      "建议您使用IE9及以上版本、Edge、Chrome、Firefox和360等主流浏览器浏览本网站",
    serviceAccount: "一网通办服务号",
    rights: "版权所有 © 重庆电信职业学院",
  },
  affairs: {
    title: "事务中心",
    collapseSearh: "收起筛选",
    expandSearh: "展开筛选",
    all: "全部",
    matterType: "事项类型:",
    handingChannel: "办理途径:",
    visiteCount: "访问次数: ",
    times: "次",
    searchMessage: "为您找到含 “{key}” 的{count}条信息",
    banner: "用更高效的方式探索世界",
  },
  analysis: {
    title: "能效分析",
    serviceEfficiency: "服务效能",
    lastWeek: "近七天",
    lastMonth: "近一个月",
    lastTreeMonth: "近三个月",
    lastYear: "近一年",
    rangeSeparator: "至",
    startPlaceholder: "开始日期",
    endPlaceholder: "结束日期",
    search: "查询",
    reset: "重置",
    serviceChart: "服务次数走势图",
    upTo: "统计截止至上个自然日",
    deptApproval: "部门参与审批次数 ",
    deptService: "部门线上服务事项次数",
    serviceCount: "服务次数 ",
    student: "学生",
    teacher: "教师",
    visitor: "访客",
    deptStats: "以服务对象所在部门办结数为维度统计",
    processApproval: "流程审批率",
    ranking: "排名",
    name: "名称",
    overallProportion: "全局占比",
    processApprovalEfficiency: "流程审批效率",
    deptApprovalCount: "部门参与审批次数",
    deptRanking: "以部门为维度统计流程审批次数最多的业务部门排行榜",
  },
  guide: {
    title: "服务指南",
    serviceRecipient: "服务对象:",
    matterNumber: "事项编号",
    matterName: "事项名称",
    matterType: "事项类型",
    department: "所属部门",
    operations: "操作",
    bookmark: "收藏",
    unbookmark: "取消收藏",
    basicInfo: "基本信息",
    handingProcess: "办理流程",
    others: "其他说明",
    feedback: "建议反馈",
    consultation: "我要咨询",
    appointment: "在线预约",
    noOthers: "暂无其他说明",
    method: "办理方式",
    handingChannel: "责任部门",
    hotline: "咨询电话",
    supervision: "监督电话",
    matterNature: "事项性质",
    handingTime: "办理时间",
    handlingEntrance: "办理入口",
  },
  systems: {
    title: "常用系统",
    department: "所属部门:",
    noPhone: "暂无电话",
  },
  myAffairs: {
    notification: "通知公告",
    schoolNotice: "全校通知公告",
    departmentNotice: "部门通知公告",
    service: "常用服务",
    systems: "常用系统",
    guide: "常用指南",
    messageCenter: "消息中心",
    schedule: "日程",
    read: "已读",
    unread: "未读",
    completed: "已办",
    uncompleted: "待办",
    pending: "待办",
    noticeTitle: "公告标题:",
    noticeType: "公告类型:",
    publishDept: "发布部门:",
    onlyUnread: "只查询未读公告",
    onlyFollow: "只查询我关注的公告",
    searchMessage: "为您找到{count}条信息",
    searchTitle: "请输入公告标题",
    myToDo: "我待办的",
    myCompleted: "我已办的",
    carbonCopy: "抄送给我",
    myInitiated: "我发起的",
    drafts: "草稿箱",
    fillingTask: "填报任务",
    sharedWithMe: "分享给我的",
    transferred: "我转办的",
    efficiencyData: "效能数据分享",
    affairName: "事项名称",
    searchHolder: "请输入",
    number: "序号",
    serviceSource: "消息来源",
    lastReceivedTime: "最后收到时间",
    personEntrusted: "被委托人",
    options: "设置操作",
    details: "详情",
    noticeDetail: "公告详情",
    pendingDetail: "待办详情",
    keyWord: "关键字",
    source: "来源",
    dateRange: "日期范围",
    title: "标题",
    content: "内容",
    date: "日期",
    manage: "管理常用",
  },
  profile: {
    myPhone: "我的手机",
    account: "账号信息",
    changePassword: "修改密码",
    logout: "用户注销",
    setting: "设置中心",
    security: "安全中心",
    thirdParty: "第三方账号",
    monitor: "监控账号",
    bind: "账户绑定",
    point: "分",
    securitySetting: "密保设置",
    loginLogs: "登录日志",
    gender: "性别",
    idCard: "居民身份证",
    accountName: "账号名",
    dentity: "身份",
    affiliation: "所属机构",
    expiryDate: "失效日期",
    active: "是否激活",
    todayis: "今天是",
    welcome: "欢迎回到",
    fengxian: "账号十分安全，建议保持",
    fengxian1: "账号存在风险，急需优化信息",
    goGood: "去优化",
    myEmail: "我的邮箱",
    loginHistory: "登录历史",
    handleDate: "筛选日期",
    startDate: "开始日期",
    browser: "浏览器",
    os: "操作系统",
    loginWay: "登录方式",
    msg: "提示信息",
    loginTime: "登录时间",
    endDate: "结束日期",
    mibao: "密保设置",
    setmibao: "已设置",
    accountType: "账号类别",
    isDefault: "是否默认",
    iszhu: "是否主账号",
    goset: "去设置",
    setnomibao: "未设置",
    yibangding: "已绑定",
    weibangding: "未绑定",
    quchakan: "去查看",
    accbind: "账号绑定",
    status: "状态",
    defaultAccount: "是否默认账号",
    operations: "操作",
    cancelDefault: "取消默认",
    passwordSetting: "请设置新密码",
    pswSettingDes:
      "本处修改的密码是学校统一身份认证的密码，即本系统的登录密码。",
    oldPwd: "旧密码:",
    newPwd: "新密码:",
    confrmPwd: "确认密码:",
    studentStaffID: "学/工号",
    departName: "所属部门",
    bindEmail: "绑定邮箱",
    phone: "手机号码",
    securityScore: "安全分数",
    securityInfo: "安全信息",
    levelLow: "较低",
    levelNormal: "一般",
    levelGood: "良好",
    levelExcellent: "优秀",
    levelAmazing: "极好",
    loginPassword: "登录密码",
    securityEmail: "安全邮箱",
    securityPhone: "安全手机",
    setNow: "立即设置",
    changeNow: "立即修改",
    passwordDesc:
      "建议您定期更换密码，密码建议使用8位以上数字、字母及特殊字符组成",
    emailDesc:
      "邮箱将是您的有效身份证，在保证安全的同时还可以提供更便捷的邮件提醒",
    phoneDesc: "安全手机可以用于登录账号，若手机号码丢失或停用，请立即更换",
    lowLevelDesc: "您的账号安全分数较低，建议加强密码，绑定所有安全认证方式",
    inputNewPwd: "请输入新密码",
    inputOldPwd: "请输入旧密码",
    cannotBeSame: "新密码不能与旧密码相同",
    inputPwdAgain: "请再次输入密码",
    pwdNotSame: "两次输入密码不一致",
    modifySuccess: "修改成功",
    thirdPartyPage: {
      title: "第三方账号",
      addAccount: "添加账号",
      accountName: "账户名称",
      password: "密码",
      appName: "第三方应用名称",
      unbind: "解除绑定",
    },
    monitorPage: {
      title: "监控账号",
      addAccount: "添加监控账号",
      accountName: "账户名称",
      loginAccount: "登录账号",
      operations: "操作",
      delete: "删除",
    },
    bindPage: {
      title: "社交账户绑定",
      wechat: "微信",
      qq: "QQ",
      dingding: "钉钉",
    },
    settingPage: {
      title: "密保设置",
      question: "密保问题",
      answer: "密保答案",
      addSecurity: "添加密保",
      operations: "操作",
      change: "修改",
      delete: "删除",
    },
    logsPage: {
      ip: "登录IP",
      time: "操作时间",
      location: "操作地点",
      device: "设备名称",
      logsDesc:
        "以下为您的账号最近的登录记录，若存在异常情况，请尽快联系管理员",
      changePwd: "修改密码",
    },
  },
  search: {
    all: "全部",
    affairs: "事务中心",
    specialized: "专题服务",
    commonSystems: "常用系统",
    serviceGuide: "服务指南",
  },
};
